import React from 'react';
import { Route, Switch } from 'react-router';
import { adminRoutes, configRoutes } from './constants';


export const ConfigRoutes = () => {

  return (
		<Switch>
			{
				[configRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />													
					)
					})					
				]
			}
		</Switch>
	);
}